import React, {CSSProperties, ReactNode} from "react";


interface EllipsisDivProp{
    style?:CSSProperties,
    children:ReactNode
}

function EllipsisDiv(props:EllipsisDivProp)
{
    const {style, children} = props;
    return (
            <div style={{ ...style
                ,   width:"100%"
                ,   alignItems: 'left'
                ,   justifyContent: 'left'
                ,   overflow : "hidden"
                ,   whiteSpace:"nowrap"
                ,   textOverflow :"ellipsis" }}>

                {children}
            </div>
    );


}
export default  EllipsisDiv;